import React from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/16/solid";
import { ComponentI } from "../../../../types";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import Button from "../../../../componentLibrary/Button";
import Checkbox from "../../../../componentLibrary/Checkbox";
import { CopyVariableButton } from "../../utils/CopyVariableButton";

export default function UserListContentCard({
  component,
  handleContentChange,
}: {
  component: ComponentI;
  handleContentChange: (
    id: string,
    field: string,
    value: string | number | Record<string, string> | boolean,
  ) => void;
}) {
  const getInitialCount = () => {
    let count = 1;
    while (component.content[`placeholder_${count}`] !== undefined) {
      count++;
    }
    return count - 1;
  };

  const handleAddInput = () => {
    const nextIndex = getInitialCount() + 1;
    handleContentChange(component._id, `placeholder_${nextIndex}`, "");
  };

  const handleRemoveLastInput = () => {
    const currentCount = getInitialCount();
    if (currentCount > 1) {
      handleContentChange(
        component._id,
        `placeholder_${currentCount}`,
        undefined,
      );
    }
  };

  return (
    <Card>
      <div className="space-y-2">
        <Input
          value={component.content.label}
          onChange={(e) =>
            handleContentChange(component._id, "label", e.target.value)
          }
          label="Label"
          placeholder="List your favorite activities"
          required
        />

        {Array.from({ length: getInitialCount() }).map((_, index) => (
          <Input
            key={index + 1}
            value={component.content[`placeholder_${index + 1}`] || ""}
            onChange={(e) =>
              handleContentChange(
                component._id,
                `placeholder_${index + 1}`,
                e.target.value,
              )
            }
            label={`Default Input ${index + 1}`}
            placeholder="Reading"
          />
        ))}

        <div className="flex space-x-2 justify-end">
          <Button
            variant="secondary"
            size="sm"
            onClick={handleRemoveLastInput}
            className="mb-1"
            disabled={getInitialCount() <= 1}
          >
            <MinusIcon className="w-4 h-4" />
          </Button>
          <Button
            variant="dark"
            size="sm"
            onClick={handleAddInput}
            className="mb-1"
          >
            <PlusIcon className="w-4 h-4" />
          </Button>
        </div>
        <Checkbox
          label="Allow Converting Placeholder Text"
          checked={component.content.convertPlaceholder}
          onChange={(e) =>
            handleContentChange(
              component._id,
              "convertPlaceholder",
              e.target.checked,
            )
          }
        />
        <Input
          value={component.content.variable}
          onChange={(e) =>
            handleContentChange(component._id, "variable", e.target.value)
          }
          label="Variable Name"
          placeholder="favorite_activities"
          required
          TopRightElement={
            <CopyVariableButton type="icon" component={component} />
          }
        />
      </div>
    </Card>
  );
}
